import Header from "./Header";
import Footer from "./Footer";

import logo from "../../logo.avif";


const faqs = [
    {
        id: 1,
        question: "Is your corporation a 501(c)(3)?",
        answer: "Yes!  We are a 501(c)(3) Pennsylvania non-profit corporation.",
    },
    {
        id: 2,
        question: "Do you accept donations?",
        answer: "Yes, please see our list of items requested below.  All items must be well cared for as we do not want to pass on anything less than what we would use on our own children.  They want to feel included with their peers and brand name items are a definite plus in helping with that.  We also welcome cash or credit card donations as well.",
    },
    {
        id: 3,
        question: "Do you accept volunteers?",
        answer: "Absolutely.  Feel free to call or text us at 570-573-3613 to get more involved.  We do, however, require background checks on all volunteers to ensure the safety of the youth that we service.",
    },
    {
        id: 4,
        question: "What is considered a high risk youth?",
        answer: "A high risk youth is a person between birth and age 18 that is currently actively involved with a local agency/support service, is a member of a family trying their hardest to make ends meet, struggling in school, has limited support, or is at risk for being entered into the “foster system”.",
    },
    // {
    //     id: 5,
    //     question: "",
    //     answer: "",
    // },
]


const FAQ = () => {

    return (
        <div className="bg-white h-screen">
            {/* Header */}
            <Header/>

            <main className="isolate mb-10">

                {/*Header Section*/}
                <div className="relative isolate px-6 pt-14 lg:px-8">
                    <div
                        aria-hidden="true"
                        className="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80"
                    >
                        <div
                            style={{
                                clipPath:
                                    'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
                            }}
                            className="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-skyBlue to-blue-400 opacity-30 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]"
                        />
                    </div>
                    <div className="animate-fadeIn mx-auto max-w-2xl py-32 sm:py-48 lg:py-56">
                        <div className="hidden sm:mb-8 sm:flex sm:justify-center">
                            <div className="relative rounded-full px-3 py-1 text-sm/6 text-gray-600 ring-1 ring-gray-900/10 hover:ring-gray-900/20">
                                Have a question? Please feel free to contact us.{' '}
                                <a href="/LandingPages/Contact" className="font-semibold text-blue-400">
                                    <span aria-hidden="true" className="absolute inset-0"/>
                                    Learn more <span aria-hidden="true">&rarr;</span>
                                </a>
                            </div>
                        </div>
                        <div className="text-center">
                            <h1 className="text-balance text-5xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
                                Helping high risk youth find a brighter future
                            </h1>
                            <p className="mt-8 text-pretty text-lg font-medium text-gray-500 sm:text-xl/8">
                                At Bridge 127, our goal is to support and empower high risk youth by providing not only much needed resources but a sense of belonging. Together, we can create lasting change in their lives.
                            </p>
                            <div className="mt-10 flex items-center justify-center gap-x-6">
                                <a
                                    href="#faq"
                                    className="rounded-md bg-blue-400 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-opacity-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                >
                                    FAQ's
                                </a>
                                <a href="#testimonials" className="text-sm/6 font-semibold text-gray-900">
                                    Testimonials <span aria-hidden="true">→</span>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div
                        aria-hidden="true"
                        className="absolute inset-x-0 top-[calc(100%-13rem)] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]"
                    >
                        <div
                            style={{
                                clipPath:
                                    'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
                            }}
                            className="relative left-[calc(50%+3rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-skyBlue to-white opacity-30 sm:left-[calc(50%+36rem)] sm:w-[72.1875rem]"
                        />
                    </div>
                </div>

                {/*Testimonial*/}
                <section id={'testimonials'} className="relative isolate overflow-hidden bg-white px-6 py-20 sm:py-20 lg:px-8">
                    <div
                        className="absolute inset-0 -z-10 bg-[radial-gradient(45rem_50rem_at_top,theme(colors.indigo.100),white)] opacity-20"/>
                    <div
                        className="absolute inset-y-0 right-1/2 -z-10 mr-16 w-[200%] origin-bottom-left skew-x-[-30deg] bg-white shadow-xl shadow-indigo-600/10 ring-1 ring-indigo-50 sm:mr-28 lg:mr-0 xl:mr-16 xl:origin-center"/>
                    <div className="mx-auto max-w-2xl lg:max-w-4xl">
                        <img
                            alt=""
                            src={logo}
                            className="mx-auto h-12"
                        />
                        <figure className="mt-10">
                            <blockquote className="text-center text-md/8 text-gray-900 sm:text-md/9">
                                <p>
                                    “I am very thankful for the opportunity to "shop" at Bridge 127. We have only been
                                    fostering for a short period of time (just over one year) and I'm filled with
                                    excitement knowing that in the future it doesn't need to be a mad dash to get basic
                                    necessities for kids who are placed in our care. When our smallest addition
                                    (currently 15 months old- placed with us at 3 weeks old) arrived on our doorstep we
                                    had ZERO baby items. We did not plan for this situation but God knew better. We
                                    scraped and shopped and asked friends but now I know exactly where I would turn in
                                    that situation! <br/> <br/>

                                    The shop was incredibly organized and everything was clean and some things
                                    were/appeared brand new! The shopping experience was easy and we made an appointment
                                    as to not be in the store with any other families during this pandemic time. Two
                                    floors of clothing, toys, and accessories, all because of people sharing their
                                    hearts and pouring out what God has done in their lives. Bridge 127 is a blessing
                                    and I'm excited to see this mission grow in Schuylkill County!”
                                </p>
                            </blockquote>
                            <figcaption className="mt-10">
                                <div className="mt-4 flex items-center justify-center space-x-3 text-base">
                                    <div className="font-semibold text-gray-900">Katie</div>
                                    <svg width={3} height={3} viewBox="0 0 2 2" aria-hidden="true"
                                         className="fill-gray-900">
                                        <circle r={1} cx={1} cy={1}/>
                                    </svg>
                                    <div className="text-gray-600">Schuylkill Haven, PA</div>
                                </div>
                            </figcaption>
                        </figure>
                    </div>
                </section>

                {/*FAQs*/}
                <div id={'faq'} className="bg-white">
                    <div className="mx-auto max-w-7xl px-6 py-12 sm:py-12 lg:px-8 lg:py-12">
                        <h2 className="text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">Frequently asked
                            questions</h2>
                        <p className="mt-6 max-w-2xl text-base/7 text-gray-600">
                            Have a different question and can’t find the answer you’re looking for? Reach out to our
                            support team by{' '}
                            <a href="/LandingPages/Contact" className="font-semibold text-blue-400 hover:text-indigo-500">
                                sending us an email
                            </a>{' '}
                            and we’ll get back to you as soon as we can.
                        </p>
                        <dl className="mt-6 space-y-8 border-t divide-y divide-gray-900/10">
                            {faqs.map((faq) => (
                                <div key={faq.id} className="pt-8 lg:grid lg:grid-cols-12 lg:gap-8">
                                    <dt className="text-base/7 font-semibold text-gray-900 lg:col-span-5">{faq.question}</dt>
                                    <dd className="mt-4 lg:col-span-7 lg:mt-0">
                                        <p className="text-base/7 text-gray-600">{faq.answer}</p>
                                    </dd>
                                </div>
                            ))}
                        </dl>
                    </div>
                </div>

            </main>

            {/* Footer */}
            <Footer/>

        </div>
    )
};

export default FAQ;
